<template>
  <div id="container">
    <div
      class="item-box-content"
      style="padding-bottom: 0;">
      <!-- 期货货期设置 -->
      <div class="item-box-add">
        <span class="title-font-style">现货货期提醒设置</span>
        <el-form
          :model="params"
          :rules="rulesparams"
          ref="ruleFormex"
          label-width="150px"
          class="demo-ruleForm"
        >
          <el-row :gutter="24">
            <el-col :span="16">
              <el-form-item
                prop="value"
                label="提醒日期:约定日期前"
                label-width="170px">
                <el-input
                  style="margin-left:10px;width:160px"
                  type="number"
                  :disabled="dateDisabled"
                  v-model.trim="params.value"
                  @keyup.enter.native="enderhandler"
                  placeholder="请输入约定日期"
                ></el-input>
                <span style="margin-left: 8px;"> 天</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
            :gutter="20"
            class="pb20">
            <el-col :span="10">
              <el-button
                style="margin-left: 30px;background: #fff;border-color: #DCDFE6;color: #4E555B"
                v-if='dateDisabled'
                @click="dateDisabled  = false"
                type="info"
                plain>修改
              </el-button>
              <el-button
                style="margin-left: 30px;"
                v-else
                @click="saveorderdata"
                type="primary">保存
              </el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <!-- diaog -->
      <el-dialog
        title="期货货期"
        :visible.sync="dialogFormVisible"
        width="400px"
        :before-close="closeDialog">
        <el-form
          :model="form"
          :rules="rules"
          ref="ruleForm">
          <el-row :gutter="20">
            <!-- <el-col :span="3">期货</el-col> -->
            <el-col :span="10.5">
              <el-form-item
                label="货期："
                label-width="80px"
                prop="startTime">
                <el-input
                  type="number"
                  v-model="form.startTime"
                  autocomplete="off"
                  style="width:78px;"></el-input>
              </el-form-item>
            </el-col>
            <el-col
              :span="2.5"
              style="padding:0;">
              <div class="content_top">——</div>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="endTime">
                <el-input
                  type="number"
                  v-model="form.endTime"
                  autocomplete="off"
                  style="width:80px;"></el-input>
                天
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col
              :span="24"
              style="padding-right:0px">
              <el-form-item
                label="提醒日期:到期前 "
                prop="closeing"
                label-width="140px">
                <el-input
                  type="number"
                  v-model="form.closeing"
                  style="width:61%;margin:0 5px;"
                  autocomplete="off"></el-input>
                <span> 天</span>
              </el-form-item>
            </el-col>
          </el-row>
          <!--  -->
        </el-form>
        <div
          slot="footer"
          class="dialog-footer">
          <el-button
            type="primary"
            @click="submitForm('ruleForm')">确 定
          </el-button>
          <el-button @click="closeDialog">取 消</el-button>
        </div>
      </el-dialog>
    </div>

    <div class="item-box-content">
      <!-- 期货货期设置 -->
      <div style="display:flex;justify-content: space-between;">
        <div class="item-box-add">
          <span
            class="title-font-style"
            style="margin-top: 3px;">期货货期设置</span>
        </div>
        <!-- <div> -->
        <el-button
          style="height: 28px;"
          type="primary"
          plain
          @click="onAdd">新增
        </el-button>
        <!-- </div> -->
      </div>

      <el-table
        :data="tableData"
        border
        style="width: 100%"
        :header-cell-style="tableHeader"
      >
        <el-table-column
          prop="deliveryDate"
          label="货期">
          <template v-slot="{ row }">
            {{row.deliveryDate}}天
          </template>
        </el-table-column>
        <el-table-column
          prop="reminderDate"
          label="提醒日期"></el-table-column>

        <el-table-column
          label="操作"
          width="100">
          <template slot-scope="scope">
            <el-button
              type="text"
              style="color:#276CFF;font-size:14px"
              @click="handleClick(scope.row)">编辑
            </el-button>
            <el-button
              type="text"
              style="color:#D35E5E !important;margin-left:10px;font-size:14px"
              @click="todeler(scope.row)"
            >删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div>
        <div class="footTitle">*说明：新增货期时间不能包含在已设置货期时间内。</div>
      </div>
    </div>
    <base-dialog
      :dialog-visible.sync="delDialog"
      @successEv="sureDelData">
      <template>
        <div style="padding: 0 30px 20px">确认删除吗？</div>
      </template>
    </base-dialog>
  </div>
</template>
<script>
  import baseDialog from '@/components/module/baseDialog'
  import {
    getAllpervodidlist,
    getDeliveryperoidAdd,
    addAllpervodid,
    deleteItem,
    updatesystem,
    updataTixingSystem
  } from '@/api/system/rightsManagement.js'
  import { expressionList } from '@/components/utils/data'
  import { deepClone } from '@/util'
  import { isSuccess } from '@/util/tool'

  var _this
  export default {
    components: {
      baseDialog
    },
    data () {
      var checkoinput = (rule, value, callback) => {
        if (!value) {
          callback(new Error('提醒日期不能为空'))
        } else if (Number(value) < 0) {
          callback(new Error('约定日期不能为负数'))
        } else if (Number(value) === 0) {
          callback(new Error('提醒日期需大于0'))
        } else if (!Number.isInteger(Number(value))) {
          callback(new Error('请输入正整数'))
        } else {
          callback()
        }
      }
      var checkAge3 = (rule, value, callback) => {
        if (!value && value !== 0) {
          callback(new Error('请输入货期'))
        } else if (Number(value) < 0) {
          callback(new Error('货期不能为负数'))
        } else if (!Number.isInteger(Number(value))) {
          callback(new Error('请输入正整数'))
        } else {
          callback()
        }
      }

      var checkAge = (rule, value, callback) => {
        if (!value && value !== 0) {
          callback(new Error('请输入货期'))
        } else if (Number(value) < 0) {
          callback(new Error('货期不能为负数'))
        } else if (!Number.isInteger(Number(value))) {
          callback(new Error('请输入正整数'))
        } else {
          callback()
        }
      }
      var checkAge2 = (rule, value, callback) => {
        if (!value) {
          callback(new Error('请输入提醒日期'))
        } else if (!Number.isInteger(Number(value))) {
          callback(new Error('请输入正整数'))
        } else if (Number(value) < 0) {
          callback(new Error('提醒天数必须大于0'))
        } else {
          callback()
        }
      }

      return {
        isedit: false,
        delDialog: false,
        tableData: [],
        form: {
          startTime: '',
          endTime: '',
          closeing: ''
        },
        dateDisabled: true,
        rules: {
          startTime: [{
            trigger: 'blur',
            validator: checkAge,
            required: true
          }],
          endTime: [{
            required: true,
            validator: checkAge3,
            trigger: 'blur'
          }],
          closeing: [{
            required: true,
            validator: checkAge2,
            trigger: 'blur'
          }]
        },
        dialogFormVisible: false,
        queryParams: {},
        params: {
          value: ''
        },
        rulesparams: {
          value: [
            {
              required: true,
              trigger: 'blur',
              validator: checkoinput
            }
          ]
        },
        contractScreenCondition: [],
        expressionList: expressionList,
        loadingTable: false, // 列表loading
        list: [{}], // 列表数据
        pageSize: 30, // 页数
        currentPage: 1, // 页码
        total: 0, // 列表总数
        value1: false,
        value2: true,
        editpartams: {},
        Math: [],
        curEditRow: {},
        curDelRow: {},
        add: false // 新增输入框状态
      }
    },
    mounted () {
      _this = this
      this.getInitTable()
    },
    methods: {
      closeDialog (done) {
        this.$refs.ruleForm.resetFields()
        this.dialogFormVisible = false
        if (done) {
          done()
        }
      },
      saveorderdata () {
        const { value } = this.params
        this.$refs.ruleFormex.validate(vaild => {
          if (vaild) {
            updatesystem(Object.assign(this.editpartams, {
              'deliveryReminder': Number(value)
            })).then(res => {
              if (isSuccess(res)) {
                this.$message.success('保存成功')
                this.dateDisabled = true
              }
            })
          }
        })
      },
      todeler (row) {
        this.delDialog = true
        this.curDelRow = row
      },
      sureDelData () {
        const { curDelRow } = this
        deleteItem(curDelRow.id).then(res => {
          if (isSuccess(res)) {
            this.$message.success('操作成功')
            this.curDelRow = null
            this.getInitTable()
          }
        })
      },
      getSelect (list) {
        const tempsum = []
        list.forEach(element => {
          // 用正则提取相关的信息
          const sum = element.deliveryDate
            .substr(0, element.deliveryDate.length - 1)
            .split('-')
          tempsum.push(sum)
        })

        const max = tempsum.flat().reduce(function (a, b) {
          return b > a ? b : a
        })

        const min = Math.min(...tempsum.flat())
        return max + '-' + min
      },

      getInitTable () {
        getAllpervodidlist().then(res => {
          if (isSuccess(res)) {
            _this.editpartams = res.data.obj.systemPlatformSetting
            _this.params.value = res.data.obj.systemPlatformSetting.deliveryReminder || ''
            _this.dateDisabled = Boolean(_this.params.value)
            _this.tableData = res.data.obj.systemDeliverySettingList
            _this.Math = _this.getSelect(_this.tableData).split('-')
          }
        })
      },

      handleClick (row) {
        this.dialogFormVisible = true
        this.curEditRow = deepClone(row)
        row = deepClone(row)
        row.deliveryDate = row.deliveryDate.replace(new RegExp('天', 'g'), '')
        row.reminderDate = row.reminderDate.replace(
          new RegExp('到期前|天', 'g'),
          ''
        )
        const { deliveryDate, reminderDate } = row
        const tempOne = deliveryDate.split('-')
        this.$set(this.form, 'startTime', tempOne[0])
        this.$set(this.form, 'endTime', tempOne[1])
        this.$set(this.form, 'closeing', reminderDate)
        this.isedit = true
      },
      submitForm (formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            const { form, tableData, curEditRow } = this
            const { startTime, endTime, closeing } = form
            if (Number(startTime) > Number(endTime)) {
              this.$message.error('请输入正确货期')
              return
            }
            if (Number(startTime) === Number(endTime)) {
              this.$message.error('时间不能相等')
              return
            }
            if (!this.isedit) {
              const systemDeliverySettingList = {
                createDate: '',
                createIp: 0,
                createUser: '',
                deliveryDate: `${startTime}-${endTime}`,
                flag: true,
                id: 0,
                reminderDate: `到期前${closeing}天`,
                serial: 0
              }
              addAllpervodid(systemDeliverySettingList).then(res => {
                this.$message({
                  message: res.data.msg,
                  type: res.data.code === 200 ? 'success' : 'error'
                })
                this.dialogFormVisible = false
                this.getInitTable()
              })
            } else {
              updataTixingSystem(Object.assign(this.curEditRow, {
                deliveryDate: `${startTime}-${endTime}`,
                reminderDate: `到期前${closeing}天`
              })).then(res => {
                if (isSuccess(res)) {
                  this.$message.success('修改成功')
                  this.getInitTable()
                  this.dialogFormVisible = false
                } else {
                  this.$message.error(res.data.msg)
                }
              })
            }
          }
        })
      },
      enderhandler () {
        if (this.params.value <= 0) {
          this.$message({
            message: '提醒天数需大于0！',
            type: 'error'
          })
          return false
        }
      },

      // 新增设置
      onAdd () {
        this.isedit = false
        this.dialogFormVisible = true
        this.form.startTime = ''
        this.form.endTime = ''
        this.form.closeing = ''
      },
      // 修改设置
      onExchange () {
      },
      // 删除设置
      onDelete () {
        this.add = false
      },
      // 发起收款
      onInitiateCollection () {
        this.$router.push({ name: 'initiateCollection' })
      },
      // 设置头部背景色
      tableHeader ({ rowIndex }) {
        return this.$tableHeader(rowIndex)
      },
      // 收款申请详情
      onDetails () {
        this.$router.push({ name: 'collectionApplicationDetails' })
      },
      // 页数
      handleSizeChange (val) {
        this.pageSize = val
        this.getList()
      },
      // 页码
      handleCurrentChange (val) {
        this.currentPage = val
        this.getList()
      }
    }
  }
</script>
<style
  lang="less"
  scoped>
  .content_top {
    width: 100%;
    display: flex;
    align-items: center;
    color: #979797;
    margin-top: 5px;

    .center_gerl {
      display: inline-block;
      width: 100%;
      height: 1px;
      background-color: red;
    }

  }

  .title-font-style {
    font-family: SourceHanSansCN-Bold, SourceHanSansCN;
    font-weight: bold;
    color: #4e555b;
    font-size: 18px;
    line-height: 20px;
    margin-bottom: 20px;
  }

  .box-center-hr {
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid #eeeeee;
  }

  .item-box-add .arrive-date {
    display: flex;
  }

  .footTitle {
    font-size: 14px;
    color: #d35e5e;
    margin-top: 18px;
  }

  /deep/ .el-dialog__footer {
    padding-top: 0 !important;
  }

  /deep/ .dialog-footer {
    margin: 0px;
    margin-left: auto !important;
  }

  /deep/ .el-button--info.is-plain {
    color: rgb(78, 85, 91);
  }

  /deep/ .el-button--info.is-plain:hover {
    color: #fff;
  }
</style>
